import config from '../../config';
export const API_URL = config.API_URL;

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/users/',
    LOGIN: '/auth/login',
    AUTH_CHECK: '/users/auth/',
	FORGOT_PASSWORD: '/auth/forgot-password',
	VERIFY_RESET_PASSWORD_OTP: '/auth/verify-reset-password-otp',
	RESET_PASSWORD: '/auth/reset-password',
  },
  USER: {
	REGISTER: '/users/signup',
	PROFILE_COMPLETED: '/users/profile-completed',
  },
  PROFILE: {
    PROFILE: '/users/profile',
    ADDRESS: '/users/address',
    BANK_INFO: '/users/bank-info',
    PERSONAL_INFO: '/users/personal-info',
  },
  CLIENTS: {
    GET: '/clients',
    CREATE: '/clients',
    UPDATE: '/clients',
    DELETE: '/clients',
  },
  INVOICES: {
    GET: '/invoices',
    CREATE: '/invoices',
    UPDATE: '/invoices',
    DELETE: '/invoices',
    DOWNLOAD_DOC: '/invoices/docs',
  },
  USER_DOCUMENTS: {
    GET: 'docs/user',
    CREATE: 'docs/user',
    DELETE: 'docs/user',
  },
  INVOICE_DOCUMENTS: {
    GET: 'docs/invoice',
    CREATE: 'docs/invoice',
    DELETE: 'docs/invoice',
	DOWNLOAD: 'docs/download'
  },
};

export const API_CONFIG = {
  TIMEOUT: 30000, // 30 seconds timeout for API requests
};
